module.exports = {
      id: "hamburger-twitter-usage",
      viewBox: "0 0 36 37",
      url: __webpack_public_path__ + "svg-sprite-39dbc991ee8a2ec1b35aeef6495011e2.svg#hamburger-twitter",
      toString: function () {
        return this.url;
      }
    }